/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-09-27 21:05:23
 * @modify date 2022-09-27 21:05:23
 * @desc 用户属性UB
 */
/**
 * BU
 * @export
 * @enum {number}
 */
export var EnumBusiness;
(function (EnumBusiness) {
    EnumBusiness["REL"] = "BU001";
    EnumBusiness["CON"] = "BU004";
    EnumBusiness["SMB"] = "BU005";
    EnumBusiness["ISG"] = "BU006";
})(EnumBusiness || (EnumBusiness = {}));
/**
 * 用户类型
 * @export
 * @enum {number}
 */
export var EnumUserType;
(function (EnumUserType) {
    /** @name 意向伙伴 */
    EnumUserType["Intention"] = "1";
    /** @name 合作伙伴 */
    EnumUserType["Cooperation"] = "2";
    /** @name Sales */
    EnumUserType["Sales"] = "3";
})(EnumUserType || (EnumUserType = {}));
/**
 * 合作类型
 * @export
 * @enum {number}
 */
export var EnumCooperateType;
(function (EnumCooperateType) {
    /** @name 注册伙伴 */
    EnumCooperateType["Registered"] = "1";
    /** @name 合作伙伴 */
    EnumCooperateType["Signing"] = "2";
})(EnumCooperateType || (EnumCooperateType = {}));
